<template>
<div id="app">
	<image-viewer v-if="$store.mainImageViewerUrl"
		:url="$store.mainImageViewerUrl"
		v-on:close="$store.mainImageViewerUrl = null">
	</image-viewer>

	<div v-if="loggedIn">
		<header v-if="!$store.printMode">
			<div class="top-bar dark-primary-color" :class="{'portal-mode':$store.portalMode,'normal-mode':!$store.portalMode}">
				<div v-if="!$store.portalMode" class="mobile-menu" v-on:click="toggleMenu">
					<i class="fa" :class="{
						'fa-bars' : !menuVisible,
						'fa-arrow-circle-left' : menuVisible && !menuIconsOnly,
						'fa-arrow-circle-right' : menuVisible && menuIconsOnly
					}"></i>
				</div>

				<!--<img v-if="$store.companyImageUrl" :src="$store.companyImageUrl" style="max-height: 35px;vertical-align: top;">-->

				<img class="top-logo" :src="logoSrc" style="height: 20px;vertical-align: top;margin-top: 8px">

				<!--<img :src="logoSrc" style="height: 20px;">-->

				<top-menu v-if="!$store.portalMode" 
					:message-panel-open="messagePanelOpen"
					:mobile-breakpoint="mobileBreakpoint"
					v-on:logout="logout" 
					v-on:newMessage="newMessageThread.visible = true"
					v-on:openMessagePanel="messagePanelOpen = true">
				</top-menu>

			</div>

			<div class="alerts-panel">
				<alert v-for="alert in alerts" 
					:key="alert.timestamp+alert.message" 
					:classes="alert.class"
					:visible="alert.visible"
					:errors="alert.errors"
					:icon="alert.icon"
					:message="alert.message"
					:self-clear="alert.selfClear"
					v-on:close="closeAlert(alert.timestamp)">
				</alert>

				<a v-if="alerts.length > 1" href="#" v-on:click.prevent="clearAlerts">Clear All Alerts</a>
			</div>

			<main-menu v-if="!$store.portalMode" :menu-visible="menuVisible"
				:icons-only="menuIconsOnly"
				v-on:openUserSwitch="openSwitchUser"
				v-on:openReferralModal="openReferralModal('Referral Link: Main Menu')">		
			</main-menu>
		</header>
		<div v-else style="margin-top: -70px;">
			Print Mode
		</div>

		<div :class="{
			'with-panel-container':messagePanelOpen,
			'menu-visible':menuVisible,
			'menu-icons-only': menuIconsOnly,
			'main-area': !messagePanelOpen && !$store.printMode && !$store.portalMode
		}">
			<div :class="{'main-with-panel':messagePanelOpen}">			
				<div :class="{
					'main-area bg-default-color':messagePanelOpen,
					'menu-visible':menuVisible,
					'menu-icons-only': menuIconsOnly
				}">
					<router-view
						:key="$route.name + $route.path"
						:style="{marginTop: mainMarginTop}"
						:has-message-panel="messagePanelOpen"
						v-on:closePanel="messagePanelOpen = false">
					</router-view>
				</div>
			</div>
			<div v-if="messagePanelOpen" class="message-panel-container">
				<messages :is-panel="true" v-on:closePanel="messagePanelOpen = false"></messages>
			</div>
		</div>
	</div>
	<div v-else-if="!routeNeedsLogin">
		<router-view
			:key="$route.name + $route.path">
		</router-view>
	</div>
	<div v-else>
		<password-reset v-if="$route.name == 'PasswordReset'"></password-reset>
		<login v-else></login>
	</div>
	<spinner v-if="spinnerVisible" :msg="spinnerMsg"></spinner>

	<!--<div v-if="$store.environment && $store.environment != 'Production'" class="environment-flag">
		You are on the '{{$store.environment}}' environment
	</div>-->

	<template v-if="!$store.portalMode">
		<div v-if="addToHomeVisible" class="add-to-home-prompt d-flex flex-row flex-wrap justify-content-between align-items-center" :style="{bottom: addToHomeBottom}">

			<button class="btn btn-primary" v-on:click="installToHome">
				<i class="fa fa-home"></i>
				Install to Home Screen
			</button>
			<i class="fa fa-times fa-2x" v-on:click="addToHomeBottom = '-100px'"></i>

		</div>

		<new-message-thread 
			:visible="newMessageThread.visible"
			v-on:closeModal="newMessageThread.visible = false" 
			:copied-thread="false"
			:job-type="newMessageThread.jobType"
			:job-id="newMessageThread.jobId"
			:recipient-ids="newMessageThread.recipientIds"
			:external-users="newMessageThread.externalUsers"
			:is-support-thread="newMessageThread.isSupportThread">
		</new-message-thread>

		<modal-dialog title="Company Invite!"
			:modal-visible="companyInviteModal.visible"
			confirm-button-text="Accept Invite"
			cancel-button-text="Decline Invite"
			:working="companyInviteModal.working"
			v-on:confirm="acceptInvite"
			v-on:closeModal="declineInvite">

			<div v-if="!companyInviteModal.working" class="text-center">
				<img :src="companyInviteModal.companyImg">
				<div>You have been invited to join {{companyInviteModal.companyName}}!</div>
			</div>
			<div v-else>
				<spinner :inline="true"></spinner>
				<p class="text-center">Hold on while we connect you to your new company!</p>
			</div>

		</modal-dialog>

		<modal-dialog :title="'Subscribe to '+$store.appName"
			:modal-visible="subscribeModalVisible"
			confirm-button-text="Subscribe"
			cancel-button-text="Not Now"
			v-on:confirm="gotoSubscription"
			v-on:closeModal="subscribeModalVisible = false">

			<div class="text-center">
				<h2>Your trial period has ended!</h2>
				<p>If you would like to continue using {{$store.appName}}, please subscribe to one of our plans.</p>
			</div>

		</modal-dialog>

		<modal-dialog 
			v-if="$store.environment == 'Demo' || $store.environment == 'Development'"
			title="Switch Users"
			:modal-visible="switchUserModal.visible"
			confirm-button-text="Switch"
			v-on:confirm="switchUser"
			v-on:closeModal="switchUserModal.visible = false">

			<field label="Users" col-class="col-md-4"
				:params="{type:'select',options:switchUserModal.usersOptions}"
				v-model="switchUserModal.email">
			</field>

		</modal-dialog>

		<modal-dialog title="Terms of Service & Privacy Policy"
			:modal-visible="tosModal.visible"
			confirm-button-text="I Agree"
			cancel-button-text="I Do Not Agree"
			v-on:confirm="tosAgree"
			v-on:closeModal="tosDisagree">

			<p>Our Terms of Service and/or Privacy Policy has updated, please review it and click "I Agree"</p>

			<iframe :src="tosSrc" width="100%" height="200"></iframe>

		</modal-dialog>

		<company-form-modal-group></company-form-modal-group>

		<referral-link-modal :visible="referralLinkModal.visible" v-on:closeModal="referralLinkModal.visible = false"></referral-link-modal>
	</template>

</div>
</template>

<script>
import Spinner from "./components/Spinner"
import Login from "./pages/Login"
import PasswordReset from "./pages/PasswordReset"
import MainMenu from "./layout_fragments/MainMenu"
import TopMenu from "./layout_fragments/TopMenu"
import Alert from "./components/Alert"
import NewMessageThread from "./components/super_components/NewMessageThread"
import ModalDialog from "./components/ModalDialog"
import Messages from "@/pages/Messages"
import Field from "@/components/Field"
import ImageViewer from "@/components/ImageViewer"
import CompanyFormModalGroup from "@/components/company_forms/CompanyFormModalGroup"
import ReferralLinkModal from "@/components/super_components/ReferralLinkModal"

import AppStartup from "@/mixins/AppStartup.js"

export default {

	name: 'App',
	components: {
		Login,
		PasswordReset,
		MainMenu,
		TopMenu,
		Alert,
		Spinner,
		NewMessageThread,
		ModalDialog,
		Messages,
		Field,
		ImageViewer,
		CompanyFormModalGroup,
		ReferralLinkModal
	},
	mixins: [AppStartup],
	data() {
		return {
			randKey: Math.random(), //key needs to be changed every route change to force a component re-render
			loggedIn: false,
			spinnerVisible: false,
			spinnerMsg: null,
			menuVisible: true,
			menuIconsOnly: false,
			menuCollapseWidth: 1600,
			alerts: [],
			newMessageThread: {
				visible: false,
				jobId: null,
				jobType: null,
				recipientIds: [],
				externalUsers: [],
				isSupportThread: false
			},
			deferredPrompt: null,
			companyInviteModal: {
				visible: false,
				companyName: "",
				companyImg: "",
				working: true
			},
			addToHomeVisible: false,
			addToHomeBottom: '-100px',
			subscribeModalVisible: false,
			mainMarginTop: this.calcMainMarginTop(),
			mobileBreakpoint: 1200,
			messagePanelOpen: false,
			switchUserModal: {
				visible: false,
				email: null,
				usersOptions: []
			},
			tosModal: {
				visible: false
			},
			referralLinkModal: {
				visible: false
			}
		}
	},
	watch: {
		'$route.path'() {
			this.key = Math.random()

			if (window.innerWidth <= this.menuCollapseWidth)
				this.menuVisible = false

			if (this.$route.path == "/login" && this.loggedIn) {
				//redirected to dashboard
				this.$router.push("/").catch(err => {})
				this.alerts = []
			}
		}
	},
	updated() {
		let vm = this
		this.$nextTick(() => {
			vm.mainMarginTop = vm.calcMainMarginTop()
		})
	},
	computed: {
		tosSrc() {
			return window.apiRoot+"TOS_PP.txt"
		},
		routeHasToolbar() {
			return false
		},
		routeKey() {
			return Math.random()
		},
		logoSrc() {
			return window.apiRoot+"resources/logo-400.png"
		},
		routeNeedsLogin() {
			if ("noAuth" in this.$route.meta && this.$route.meta.noAuth) {
				return false
			}
			else 
				return true
		}
	},
	methods: {
		tosAgree() {
			let vm = this

			this.postData("User/acknowledge-tos").then(response => {
				if (response.success) {
					vm.$store.userDetails.tos_hash = response.data.tos_hash
					vm.$store.userDetails.tosUpToDate = true
					vm.tosModal.visible = false
					localStorage.userDetails = JSON.stringify(vm.$store.userDetails)
				}
			})
		},
		tosDisagree() {
			this.tosModal.visible = false
			this.logout()
		},
		openSwitchUser() {
			let vm = this

			if (this.switchUserModal.usersOptions.length == 0) {
				let params = {
					include: [
						{model: "UserPermission",fields: ["role_type"]}
					],
					fields: ["id","slug","first_name","last_name","email"]
				}
				this.getJSON("User/get",params).then(response => {
					if (response.success) {
						vm.switchUserModal.usersOptions = response.data.map(user => {

							let text = ""
							if ("UserPermission" in user)
								text = user.first_name+" "+user.last_name+" ("+user.UserPermission[0].role_type+")"
							else
								text = user.first_name+" "+user.last_name

							return {
								text: text,
								value: user.email
							}
						})
					}
				})
			}
			this.switchUserModal.visible = true
		},
		switchUser() {
			let vm = this

			this.postData("User/authenticate",{email:this.switchUserModal.email,password:"none"}).then(response => {
				if (response.success) {

					localStorage.clear()

					localStorage.apiKey = response.data.api_key
					localStorage.sessionToken = JSON.stringify(response.data.session_token)
					localStorage.staySignedIn = true

					vm.$bus.$emit("updateUserPermissions",response.data)

					vm.$bus.$emit("loginStatus",true)

					vm.$bus.$emit("messagePollRequest")

					location.reload()
				}
			})
		},
		gotoSubscription() {
			this.subscribeModalVisible = false
			this.$router.push('/settings/tradetraks-subscription').catch(err => {})
		},
		acceptInvite() {
			let vm = this

			vm.companyInviteModal.working = true
			this.postData("CompanyUser/accept-employment",{token: this.$store.userDetails.UserPermission[0].slug}).then(response => {

				vm.$store.userDetails.UserPermission[0].invite_accepted = response.data.invite_accepted
				localStorage.userDetails = JSON.stringify(vm.$store.userDetails)

				location.reload()
			})
		},
		declineInvite() {

			let vm = this
			vm.companyInviteModal.working = true
			this.postData("CompanyUser/decline-employment",{token: this.$store.userDetails.UserPermission[0].slug}).then(response => {
				vm.$router.push("/employers")
				vm.companyInviteModal.visible = false
				vm.companyInviteModal.working = false
			})
		},
		calcMainMarginTop() {
			let topBarHeight = document.querySelector(".toolbar") ? document.querySelector(".toolbar").clientHeight : 0

			if (window.innerWidth < this.mobileBreakpoint)
				topBarHeight = 0

			topBarHeight += 45

			if (this.$store.portalMode)
				topBarHeight = 45;

			return topBarHeight+"px"
		},
		/* NOT IN USE YET
		installToHome() {
			let vm = this

			this.deferredPrompt.prompt()
			vm.addToHomeBottom = "-100px"

			this.deferredPrompt.userChoice.then(choice => {
				
			})

		},*/
		toggleSpinner(visibility) {
			this.spinnerVisible = visibility
		},
		toggleMenu() {
			if (this.menuVisible && !this.menuIconsOnly) {
				this.menuVisible = false

				this.$store.mainAreaOffset = 0
			}
			else {
				this.menuVisible = true
				this.menuIconsOnly = false
				this.$store.mainAreaOffset = "250px"
			}

			this.$bus.$emit("mainMenuToggled",this.menuVisible)

			let vm = this
			//wait for slide out/in to finish
			setTimeout(() => {
				vm.$bus.$emit("mainMenuToggleFinished",vm.menuVisible)
				vm.mainMarginTop = vm.calcMainMarginTop()
			},500)
		},
		openReferralModal(key) {
			this.referralLinkModal.visible = true

			this.registerEngagementClick(key);
		},
		logout() {

			//deregister notification userId
			let payload = {
				device_id: this.$store.oneSignalDeviceId,
				deregister: true
			}

			if ("apiKey" in localStorage && localStorage.apiKey) {
				this.postData("User/register-notifications",payload)
			}

			this.alerts = []

			this.$store.userDetails = {}
			this.clearStore()

			clearInterval(this.$store.sessionTimer)
			clearInterval(this.$store.messagePollingTimer)
			clearInterval(this.$store.userActiveTimer)

			localStorage.clear()

			if (typeof OneSignal != 'undefined') {
				OneSignal.push(() => {
					OneSignal.removeExternalUserId()
				})
			}

			//this.fetchClockStatus()
			this.loggedIn = false;
			this.$router.push("/").catch(err => {})
		}
	},
	mounted() {
		let vm = this

		this.checkApiKey() //if API key is not in localstorage, set login state to false
		this.checkAppVersion()
		this.setMenuState()

		if (window.innerWidth < vm.$store.messagePanelBreakpoint)
			vm.messagePanelOpen = false

		this.$store.apiRoot = window.apiRoot

		var OneSignal = OneSignal || [];
		OneSignal.push(() => {
			OneSignal.on("subscriptionChange",vm.showNotificationPrompt)
			OneSignal.on("permissionPromptDisplay",vm.showNotificationPrompt)
		})

		//ROUTE NAVIGATION HOOK
		this.$router.afterEach(this.routerAfterEach)
		this.$router.beforeEach(this.routerBeforeEach)

		this.$bus.$on("newThread",this.onNewThread)
		this.$bus.$on("newSupportThread",this.onNewSupportThread)
		this.$bus.$on("newThreadCreated", this.onNewThreadCreated)
		this.$bus.$on("spinner", this.onSpinner)
		this.$bus.$on("loginStatus", this.onLoginStatus)
		this.$bus.$on("logout",this.logout)
		this.$bus.$on("pushAlert",this.onPushAlert)
		this.$bus.$on("clockStatusChanged",this.onClockStatusChanged)
		this.$bus.$on("updateUserPermissions",this.onUpdateUserPermissions)
		this.$bus.$on("messagePollRequest", this.checkNewMessages)
		this.$bus.$on("closeMessagePanel",() => {vm.messagePanelOpen = false})
		this.$bus.$on("openMessagePanel",() => {vm.messagePanelOpen = true})
		this.$bus.$on("openMainMenu",() => this.menuVisible = true)

		this.$bus.$on("openReferralModal",this.openReferralModal)

		//ADD TO HOME PROMPT: Working, just not necessary yet while Chrome still uses the Mini Info Bar (which can't be disabled in favour of a custom prompt)
		/*window.addEventListener('beforeinstallprompt', (e) => {
		  // Prevent Chrome 67 and earlier from automatically showing the prompt
		  e.preventDefault();

		  vm.addToHomeBottom = "0"
		  vm.addToHomeVisible = true

		  // Stash the event so it can be triggered later.
		  vm.deferredPrompt = e;
		});*/

		if (this.loggedIn) {

			this.setSessionToken()

			this.setUserDetails()
			this.fetchCurrentSubscription()
			this.fetchNotifications(false,this.$store.maxRecentNotifications)
			this.fetchLatestReleaseNote()

			//set from local storage, then fetch new perms via ajax
			let localStoragePerms, localStorageModules
			try {
				localStoragePerms = JSON.parse(localStorage.userDetails).UserPermission[0]
			}
			catch(e){
				localStoragePerms = {role_type: "Basic"}	
			}

			try {
				localStorageModules = JSON.parse(localStorage.userDetails).Modules
			}
			catch (e) {
				localStorageModules = []
			}

			this.storeUserPermissions(localStoragePerms,localStorageModules)

			try {
				let promises = [
					this.getJSON("User/find/"+this.$store.userDetails.slug,{include:["UserPermission"]}),
					this.getJSON("Module/get"),
					this.postData("UserToken/create",{user_id:this.$store.userDetails.id,expiry_hrs:12})
				]

				let vm = this

				Promise.all(promises).then(function(responses){

					if (responses[0].success && responses[0].data.UserPermission.length > 0) {
						vm.storeUserPermissions(responses[0].data.UserPermission[0],responses[1].data)
						vm.checkCompanyInvites() 
					}

					if (responses[2].success)
						localStorage.sessionToken = JSON.stringify(responses[2].data)

				})
			}
			catch(e){}

			//set up event listener for mouse move, so we can turn off frequent polling if user is not active
			window.addEventListener('mousemove',this.resetSessionTimer);
			window.addEventListener('resize',() => {
				vm.mainMarginTop = vm.calcMainMarginTop()

				if (window.innerWidth < vm.$store.messagePanelBreakpoint)
					vm.messagePanelOpen = false
			})

			this.initOneSignal()

			this.setEnvLabels()
			//this.setupPushNotifications(true)

			this.registerOneSignalId()
			this.showNotificationPrompt()

			this.checkNewMessages()
			this.fetchClockStatus()

			this.fetchCompanyData(false,["CompanySetting","AddonApp","ProfileImage"])
			this.setUserAssignedServices()

			this.startMessagePolling()
			this.startNotificationPolling()

			if (!("staySignedIn" in localStorage) || localStorage.staySignedIn == 'false') {
				clearTimeout(this.$store.sessionTimer)
				this.startSessionTimer()
			}
			
		}	
		else if ("loggedOutRedir" in this.$route.query)
			//user is logged out, if there is a redirect, send them there
			window.location = this.$route.query.loggedOutRedir

		this.mainMarginTop = this.calcMainMarginTop()

		if (this.$route.path == "/login" && this.loggedIn) //redirected to dashboard 
			this.$router.push("/")

		//this.postData("QuickbooksConnection/push-invoice",{invoice_slug:"aa8d8e2c72c5312bbfc7c1caa5189a09b255c2e5"})

		window.addEventListener("resize",event => {
			vm.debounce(() => {
				vm.$store.windowWidth = window.innerWidth
			},null,250)
		})
	}
}
</script>

<style>

	.environment-flag {
		position: fixed;
		bottom: 0;
		left: 0;
		color: red;
		padding-left: 10px;
	}

	.add-to-home-prompt {
		position: fixed;
		z-index: 100;
		left: 0;
		right: 0;
		bottom: 0;
		background: #fff;
		padding: 10px;
		box-shadow: 0 0 10px rgba(10,10,10,0.5);
		transition: bottom 0.5s;
		color: #606060;
	}

	.add-to-home-prompt .fa-times {
		margin-left: 15px;
	}

	.container-fluid {
		transition: margin-top 0.5s;
	}

	.with-panel-container {
		position: relative;
		display: flex;
		flex-direction: row;
	}

	.main-with-panel {
		width: 75%;
	}

	.message-panel-container {
		width: 25%;
	}

	
	@media (max-width: 670px) {
		.top-logo {
			display: none;
		}
	}

</style>
